import { CustomSchema, SchemaName } from "./types"
import { schemas } from "./schames";


export function getSchema<T>(schemaName: SchemaName): CustomSchema<T>[] {
  return schemas[schemaName];
}
